/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

//import { ContentEditableEvent } from '@msdyn365-commerce/core';
import { LogLevel } from '@msdyn365-commerce/telemetry-internal';
import * as React from 'react';
import { Container } from '../../nickComponents/base-components';
import { Heading } from '@msdyn365-commerce-modules/utilities';
import { colWidths } from '../../nickComponents/classnames';
import { ILiquidContainerData } from './liquid-container.data';
import { childrenWidth as childrenWidthEnum, ILiquidContainerProps, layout as layoutEnum } from './liquid-container.props.autogenerated';

/**
 *
 * CoreComponent component
 * @extends {React.PureComponent<ILiquidContainerProps<ILiquidContainerData>>}
 */
class LiquidContainer extends React.PureComponent<ILiquidContainerProps<ILiquidContainerData>> {
    constructor(props: ILiquidContainerProps<ILiquidContainerData>) {
        super(props);
    }

    public render(): JSX.Element {
        const { slots, telemetry, config } = this.props;
        telemetry.log(LogLevel.Debug, "Liquid Container rendering for '{id}/{typeName}'", {
            values: [this.props.id, this.props.typeName]
        });

        const { heading } = this.props.config;


        // // const heading = config.heading || data.heading;
        // const liquidTitleProps = {
        //     ...heading,
        //     title: liquidTitle,
        // };
        

        

        return (
            <Container
                containerType={config.containerType}
                className={config.className}
                ariaLabel={config.ariaLabel}
                typeName={this.props.typeName}
                id={this.props.id}
                request={this.props.context.request}
                backgroundImage={config?.backgroundImage}
                backgroundImageRepeat={config?.backgroundImageRepeat}
                backgroundImageSize={config?.backgroundImageSize}
                // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unnecessary-type-assertion
                moduleLayout={(config as any)?.msdyn365__moduleLayout}
            >
                {heading && heading.text && <Heading className='container-heading' headingTag={heading.tag} text={heading.text} />}

                {slots &&
                    slots.content &&
                    slots.content.map((children: React.ReactNode, index: number) => {
                        return (
                            <div className={this._getChildColClassName()} key={index}>
                                {children}
                            </div>
                        );
                    })}
            </Container>
        );
    }

    //public handleTextChange = (event: ContentEditableEvent) => (this.props.config.heading!.text = event.target.value);

    private _getChildColClassName(): string {
        const {
            config: { layout, childrenWidth }
        } = this.props;
        switch (layout) {
            case layoutEnum.flow:
                return childrenWidth === childrenWidthEnum.auto ? 'col-12 col-md' : this._getWidthClass(childrenWidth);
            case layoutEnum.stacked:
            default:
                return 'col-12';
        }
    }

    private _getWidthClass(s?: childrenWidthEnum): string {
        return colWidths.get(s || childrenWidthEnum.four) || 'col-12';
    }
}

export default LiquidContainer;
